import { render, staticRenderFns } from "./editRoom.vue?vue&type=template&id=2c991fe2&scoped=true&"
import script from "./editRoom.vue?vue&type=script&lang=js&"
export * from "./editRoom.vue?vue&type=script&lang=js&"
import style0 from "./editRoom.vue?vue&type=style&index=0&id=2c991fe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c991fe2",
  null
  
)

export default component.exports